import { useQuery } from '@apollo/client'
import { getMyDirectThreadList as getMyDirectThreadListGql }
   from 'src/graphql/queries/getMyDirectThreadList.gql'

const useMyDirectThreadList = (variables, options) => {
   const { data, ...otherQueryReturnValues } = useQuery(getMyDirectThreadListGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      ...options
   })

   return {
      ...otherQueryReturnValues,
      myDirectThreadList: data
         ? data.getMyDirectThreadList
         : { items: [], listInfo: {} }
   }
}

export default useMyDirectThreadList
